import { useEffect } from "react";
import { useState } from "react";
import { createContext } from "react";

const AppContext = createContext({

});

export const AppContextProvider = ({ children }) => {

  const [initialized, setInitialized] = useState(false);

  console.log("initialized", initialized);
  return (
    <AppContext.Provider
      value={{
        initialized,
        setInitialized,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;
